// src/routes/AppRoutes.js
import { Routes, Route, Navigate } from "react-router-dom";
import { useContext, lazy, Suspense } from "react";
import { AppContext } from "../AppContext";

// Import các trang
import HomePage from "../pages/HomePage";
import LoginPage from "../pages/LoginPage";
import RegisterPage from "../pages/RegisterPage";
import CourseDetailPage from "../pages/CourseDetailPage";
import PracticeDetailPage from "../pages/PracticeDetailPage";

import GuidePage from "../pages/GuidePage";
import VerifyPage from "../pages/VerifyPage";
import ContactPage from "../pages/ContactPage";
import CoursesPage from "../pages/CoursesPage";
import QuizPage from "../pages/QuizPage";
import PracticePage from "../pages/PracticePage";
import TopicPage from "../pages/TopicPage";
import TopicDetailPage from "../pages/TopicDetailPage";

import AdminRoute from "./AdminRoute";

// Trang quản trị và bảng thù lao giáo viên tách thành file riêng, chỉ tải khi mở:
// học sinh không phải tải phần code quản lý trung tâm.
const AdminPage = lazy(() => import("../pages/AdminPage"));
const AdminLoginPage = lazy(() => import("../pages/AdminLoginPage"));
const TeacherReportPage = lazy(() => import("../pages/TeacherReportPage"));
// Trang hồ sơ kèm popup nạp xu (thư viện Pusher), ít người mở
const ProfilePage = lazy(() => import("../pages/ProfilePage"));

const PageLoading = () => (
  <div className="text-center py-16">
    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-purple-500 mx-auto mb-3"></div>
    <p className="text-gray-600">Đang tải...</p>
  </div>
);

export default function AppRoutes() {
  const { isAdminLoggedIn } = useContext(AppContext);

  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/courses" element={<CoursesPage />} />
        {/* /course/1/<mã mục>: link riêng của một mục (video hoặc bài tập) để gửi cho học sinh */}
        <Route
          path="/course/:courseId/:lessonId?"
          element={<CourseDetailPage />}
        />
        <Route path="/practice" element={<PracticePage />} />
        <Route path="/practice/:id" element={<PracticeDetailPage />} />
        <Route path="/topic" element={<TopicPage />} />
        <Route path="/topic/:id" element={<TopicDetailPage />} />
        <Route path="/quiz" element={<QuizPage />} />
        <Route path="/guide" element={<GuidePage />} />
        <Route path="/verify" element={<VerifyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/profile" element={<ProfilePage />} />{" "}
        <Route path="/adminLogin" element={<AdminLoginPage />} />
        <Route
          path="/admin"
          element={
            <AdminRoute isAdminLoggedIn={isAdminLoggedIn}>
              <AdminPage />
            </AdminRoute>
          }
        />
        {/* Bảng thù lao của giáo viên: /thay-chau-tuan/thang-10-2026?k=... (trang riêng, không có menu) */}
        <Route
          path="/:teacherSlug/:monthSlug"
          element={<TeacherReportPage />}
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Suspense>
  );
}
